export const AUTH_EVENTS = {
  LOGOUT: "auth:logout",
  LOGIN: "auth:login",
  REFRESH: "auth:refresh",
} as const;

export const AUTH_CHANNEL_NAME = "auth-status";
